var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "autocomplete app-search",
      on: {
        mouseover: function ($event) {
          _vm.displayResult = true
        },
        mouseleave: function ($event) {
          _vm.displayResult = false
        },
      },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.search,
            expression: "search",
          },
        ],
        staticClass: "form-control",
        attrs: { type: "text", placeholder: "Search here" },
        domProps: { value: _vm.search },
        on: {
          keydown: function ($event) {
            _vm.displayResult = true
          },
          focus: function ($event) {
            _vm.displayResult = true
          },
          input: function ($event) {
            if ($event.target.composing) return
            _vm.search = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _vm.displayResult
        ? [
            _vm.search.length
              ? _c(
                  "ul",
                  { staticClass: "autocomplete-results" },
                  [
                    _vm.search.length && _vm.search.length < 3
                      ? _c("li", { staticClass: "autocomplete-no-result" }, [
                          _vm._v(
                            _vm._s(
                              _vm.trans(
                                "general.type_min_3_char_for_search_result"
                              )
                            )
                          ),
                        ])
                      : _vm.search.length >= 3 && _vm.resultLoading
                      ? _c("li", { staticClass: "autocomplete-no-result" }, [
                          _vm._v(_vm._s(_vm.trans("general.loading_progress"))),
                        ])
                      : _vm.search.length >= 3 &&
                        !_vm.student_search_results.length &&
                        !_vm.employee_search_results.length &&
                        _vm.search.length &&
                        !_vm.resultLoading
                      ? _c("li", { staticClass: "autocomplete-no-result" }, [
                          _vm._v(_vm._s(_vm.trans("general.no_result_found"))),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.student_search_results.length
                      ? [
                          _c("li", { staticClass: "autocomplete-heading" }, [
                            _vm._v(_vm._s(_vm.trans("student.student"))),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.student_search_results, function (result) {
                            return _c(
                              "li",
                              { staticClass: "autocomplete-result" },
                              [
                                _c("div", { staticClass: "item-info" }, [
                                  _c("h5", { staticClass: "item-heading" }, [
                                    _vm._v(
                                      _vm._s(_vm.getStudentName(result.student))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "item-meta" }, [
                                    _c("span", { staticClass: "father-name" }, [
                                      _vm._v(
                                        _vm._s(
                                          result.student.parent
                                            .first_guardian_name
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "contact" }, [
                                      _vm._v(
                                        " / " +
                                          _vm._s(result.student.contact_number)
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "item-meta" }, [
                                    _c(
                                      "span",
                                      { staticClass: "course-batch" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            result.batch.course.name +
                                              " " +
                                              result.batch.name
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-actions" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: `/student/${result.student.uuid}`,
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            _vm.search = ""
                                          },
                                        },
                                      },
                                      [_c("i", { staticClass: "fas fa-user" })]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: `/student/${result.student.uuid}/fee/${result.id}`,
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            _vm.search = ""
                                          },
                                        },
                                      },
                                      [_c("i", { staticClass: "fas fa-coins" })]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.employee_search_results.length
                      ? [
                          _c("li", { staticClass: "autocomplete-heading" }, [
                            _vm._v(_vm._s(_vm.trans("employee.employee"))),
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.employee_search_results,
                            function (result) {
                              return _c(
                                "li",
                                { staticClass: "autocomplete-result" },
                                [
                                  _c("div", { staticClass: "item-info" }, [
                                    _c("h5", { staticClass: "item-heading" }, [
                                      _vm._v(
                                        _vm._s(_vm.getEmployeeName(result))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "item-meta" }, [
                                      _c("span", { staticClass: "contact" }, [
                                        _vm._v(
                                          " / " + _vm._s(result.contact_number)
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "item-meta" }, [
                                      _c(
                                        "span",
                                        { staticClass: "course-batch" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getEmployeeDesignationOnDate(
                                                result
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "item-actions" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: `/employee/${result.uuid}`,
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              _vm.search = ""
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-user",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }